import { defineMessages } from 'react-intl'

export default defineMessages({
  extraFiles: {
    id: 'extraFiles',
    defaultMessage: 'Required files types: 1 file of each extension: .shp, .dbf, .shx. Remove unnecessary files.',
  },
  missingShp: {
    id: 'missingShp',
    defaultMessage: 'Missing file type: .shp file missing!',
  },
  missingDbf: {
    id: 'missingDbf',
    defaultMessage: 'Missing file type: .dbf file missing!',
  },
  missingShx: {
    id: 'missingShx',
    defaultMessage: 'Missing file type: .shx file missing!',
  },
  dragFiles: {
    id: 'dragFiles',
    defaultMessage: 'Drag files onto this area or:',
  },
  click: {
    id: 'click',
    defaultMessage: 'click',
  },
  here: {
    id: 'here',
    defaultMessage: 'here',
  },
  toAdd: {
    id: 'toAdd',
    defaultMessage: ' to add files',
  },
  uploadBordersFor: {
    id: 'uploadBordersFor',
    defaultMessage: 'Upload Field Borders for:',
  },
  'existingBorderWarning': {
    id: 'existingBorderWarning',
    defaultMessage: 'A border already exists for this field.  Uploading a new border will replace the existing one.',
  },
})
